import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useUpdateUserEmailMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IUser) => void;
}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ newEmail, reason, forUserId }: { newEmail: string; reason: string; forUserId: string }) => {
			return userSession.webServiceHelper.callAsync<Api.IUser>(`user/changeEmail?forUserId=${forUserId}`, 'POST', {
				newEmail,
				reason,
			});
		},
		onError,
		onSuccess,
	});
}
